import type { ApiReturnTextResource } from '@highimpact-frontend/api-types';
import { api_config } from '../../../api-commons';
import type { ApiResource, IResourceService } from './IResourceService';

export const defineQueryParams = (params: ApiResource) => {
  const site = params.site_id ? `&site_id=${params.site_id}` : '';
  const device = params.device_id ? `&device_id=${params.device_id}` : '';
  return `name=${params.name}&project_id=${params.project_id}&type=${params.type}${site}${device}`;
};

export class TextResourceService
  implements IResourceService<ApiResource, ApiReturnTextResource>
{
  async add(params: ApiResource): Promise<ApiReturnTextResource> {
    const queryParams = defineQueryParams(params);
    const form = new FormData();
    form.append('text', params.value as string);
    const response = await api_config.post(`/resources/?${queryParams}`, form);
    return response.data;
  }

  async update(
    id: number,
    params: ApiResource
  ): Promise<ApiReturnTextResource> {
    const queryParams = defineQueryParams(params);
    const form = new FormData();
    form.append('text', params.value as string);
    const response = await api_config.put(
      `/resources/${id}?${queryParams}`,
      form
    );
    return response.data;
  }

  async delete(id: number): Promise<ApiReturnTextResource> {
    const response = await api_config.delete(`/resources/${id}`);
    return response.data;
  }

  async get(ids: number[]): Promise<ApiReturnTextResource[]> {
    const qyeryParams = ids.map((id) => `ids=${id}`).join('&');
    const response = await api_config.get(`/resources/ids/?${qyeryParams}`);
    return response.data;
  }
}

const textService = new TextResourceService();
export default textService;
